import { Injectable } from '@angular/core';
import { AlertType } from './alert.model';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  readonly default_duration = 8000;

  constructor(public toastController: ToastController, private translate: TranslateService) {
  }

  showInfo(message: string, translateParams = {}): void {
    this.addNext(AlertType.Primary, message, translateParams);
  }

  showDanger(message: string, translateParams = {}): void {
    this.addNext(AlertType.Danger, message, translateParams);
  }

  showWarning(message: string, translateParams = {}): void {
    this.addNext(AlertType.Warning, message, translateParams);
  }

  // add other types if needed (alert.model.ts/AlertType)

  async presentToast(msg: string, color: string, icon: string, duration: number) {
    const toast = await this.toastController.create({
      color: color,
      message: msg,
      icon: icon,
      duration: duration,
      buttons: [{
        icon: 'close',
        role: 'cancel'
      }
      ]
    });
    await toast.present();
  }

  private addNext(type: AlertType, message: string, translateParams = {}): void {
    let color;
    let icon;
    let duration;

    switch (type) {
      case AlertType.Primary:
        color = 'primary';
        icon = 'information-circle';
        duration = this.default_duration;
        break;
      case AlertType.Danger:
        color = 'danger';
        icon = 'alert-circle';
        duration = 0;
        break;
      case AlertType.Warning:
        color = 'warning';
        icon = 'warning';
        duration = this.default_duration;
        break;
      default:
        color = 'primary';
        icon = 'information-circle';
        duration = this.default_duration;
        break;
    }

    const translatedMsg = this.translate.instant(message, translateParams);

    this.presentToast(translatedMsg, color, icon, duration);
  }
}
